import { render, staticRenderFns } from "./BuildingOwner.vue?vue&type=template&id=59f9a550&"
import script from "./BuildingOwner.vue?vue&type=script&lang=js&"
export * from "./BuildingOwner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports